module.exports = __webpack_public_path__ + "static/ogp-7fec40789d868039837c80f3e9bd7782.png";